/**
 * Teak Quote List — renders the localStorage-backed quote list on
 * /pages/quote. Reactive: subscribes to TeakQuote events so changes
 * (add, remove, qty update) reflect immediately.
 */

(function () {
  if (window.__TeakQuoteListInit) return;
  window.__TeakQuoteListInit = true;

  function formatMoney(cents, currency) {
    const amount = (cents / 100).toFixed(2);
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: currency || 'AUD',
      currencyDisplay: 'symbol',
    }).format(Number(amount)).replace(/\.00\b/g, '');
  }

  function init() {
    const root = document.querySelector('[data-teak-quote-list]');
    if (!root) return;
    if (!window.TeakQuote) {
      console.error('TeakQuote storage missing on quote list page');
      return;
    }

    const skeleton = root.querySelector('[data-teak-quote-skeleton]');
    const emptyState = root.querySelector('[data-teak-quote-empty]');
    const filledState = root.querySelector('[data-teak-quote-filled]');
    const itemsList = root.querySelector('[data-teak-quote-items]');
    const itemTemplate = root.querySelector('[data-teak-quote-item-template]');
    const summaryCount = root.querySelector('[data-teak-quote-summary-count]');
    const summaryTotal = root.querySelector('[data-teak-quote-summary-total]');

    function renderItem(item) {
      const node = itemTemplate.content.firstElementChild.cloneNode(true);
      node.dataset.variantId = item.variantId;

      const link = node.querySelector('[data-teak-quote-item-link]');
      const image = node.querySelector('[data-teak-quote-item-image]');
      const titleLink = node.querySelector('[data-teak-quote-item-title-link]');
      const variantEl = node.querySelector('[data-teak-quote-item-variant]');
      const priceEl = node.querySelector('[data-teak-quote-item-price]');
      const qtyInput = node.querySelector('[data-teak-quote-item-qty]');
      const decreaseBtn = node.querySelector('[data-teak-quote-item-decrease]');
      const increaseBtn = node.querySelector('[data-teak-quote-item-increase]');
      const removeBtn = node.querySelector('[data-teak-quote-item-remove]');

      link.href = item.url;
      titleLink.href = item.url;
      titleLink.textContent = item.title;
      image.src = item.imageUrl;
      image.alt = item.title;

      if (item.variantTitle) {
        variantEl.textContent = item.variantTitle;
        variantEl.hidden = false;
      }

      priceEl.textContent = formatMoney(item.priceCents, item.currency);
      qtyInput.value = item.quantity;

      decreaseBtn.addEventListener('click', () => {
        const newQty = Math.max(1, item.quantity - 1);
        window.TeakQuote.setQuantity(item.variantId, newQty);
      });
      increaseBtn.addEventListener('click', () => {
        window.TeakQuote.setQuantity(item.variantId, item.quantity + 1);
      });
      qtyInput.addEventListener('change', () => {
        const next = parseInt(qtyInput.value, 10);
        if (Number.isFinite(next) && next > 0) {
          window.TeakQuote.setQuantity(item.variantId, next);
        } else {
          qtyInput.value = item.quantity;
        }
      });
      removeBtn.addEventListener('click', () => {
        window.TeakQuote.remove(item.variantId);
      });

      return node;
    }

    function renderSummary(items) {
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      const totalCents = items.reduce((sum, item) => sum + (item.priceCents * item.quantity), 0);
      const currency = items[0]?.currency || 'AUD';

      summaryCount.textContent = count;
      summaryTotal.textContent = formatMoney(totalCents, currency);
    }

    function render() {
      const items = window.TeakQuote.all();
      skeleton.hidden = true;
      skeleton.style.display = 'none';

      if (items.length === 0) {
        emptyState.hidden = false;
        filledState.hidden = true;
        itemsList.innerHTML = '';
        return;
      }

      emptyState.hidden = true;
      filledState.hidden = false;
      itemsList.innerHTML = '';
      items.forEach((item) => itemsList.appendChild(renderItem(item)));
      renderSummary(items);
    }

    render();
    document.addEventListener('teak:quote:changed', render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
